import React from "react";
import { Modal } from "antd";

const Section = ({ title, items = [] }) =>
  items.length === 0 ? null : (
    <div style={{ marginBottom: 16 }}>
      <h4>
        {title} ({items.length})
      </h4>
      <ul>
        {items.map((r) => (
          <li key={r.luId}>
            <strong>{r.name}</strong>
            {r.reasons && r.reasons.length > 0 ? ` — ${r.reasons.join("; ")}` : ""}
          </li>
        ))}
      </ul>
    </div>
  );

const TutorialPublishResultModal = ({ visible, results = [], onClose }) => {
  const published = results.filter((r) => r.status === "published");
  const blocked = results.filter((r) => r.status === "blocked");
  const skipped = results.filter((r) => r.status === "skipped");
  const failed = results.filter((r) => r.status === "failed");

  return (
    <Modal title="Publish Tutorial — Results" open={visible} onCancel={onClose} onOk={onClose} footer={null}>
      <Section title="✅ Published" items={published} />
      <Section title="⚠️ Needs fixing" items={blocked} />
      <Section title="⏭️ Skipped" items={skipped} />
      <Section title="❌ Failed" items={failed} />
      {results.length === 0 ? <p>No learning units to publish.</p> : null}
    </Modal>
  );
};

export default TutorialPublishResultModal;
